import formatErrorMessage from "../../../utils/formatErrorMessage.js";
import * as React from "react";
const MenuPositionerContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") MenuPositionerContext.displayName = "MenuPositionerContext";
function useMenuPositionerContext(optional) {
  const context = React.useContext(MenuPositionerContext);
  if (context === void 0 && !optional) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>." : formatErrorMessage(33));
  }
  return context;
}
export {
  MenuPositionerContext,
  useMenuPositionerContext
};
//# sourceMappingURL=MenuPositionerContext.js.map
